// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular.json`.

declare var assetBasePaths
export const environment = {
  production: false,
  environmentCitectBaseAPIURL : window['environmentCitectBaseAPIURL'],
  environmentBerlinBaseAPIURL : window['environmentBerlinBaseAPIURL'],
  environmentBaseBerlinApplicationURL : window['environmentBaseBerlinApplicationURL'],
  environmentGCSResourceServerURL : window['environmentGCSResourceServerURL'],
  enviornmentBasePath : window['enviornmentBasePath'],
  environmentAVEVALogoURL : `${assetBasePaths}` + "/images/AVEVA_logo_white_RGB.png",
 // environmentAVEVALogoAltURL: `${assetBasePaths}` + "/images/AVEVA_logo_blue_RGB.png"
  environmentAVEVALogoAltURL: `${assetBasePaths}` + "/images/avevaaltlogo.svg"


};
